export enum DeskStatus {
    Open = 1,
    Pause = 2,
    Closed = 3
}